<template>
  <v-card
    :style="{
      background: value.sectionColor.backGround,
      color: value.sectionColor.text,
    }"
    :dir="isCurrentLangRTL ? 'rtl' : 'ltr'"
    class="pa-4 rounded-0"
    flat
  >
    <v-card-title 
      class="section-title pa-2" 
      :class="[isCurrentLangRTL ? 'text-right' : 'text-left title-ltr']"
      style="color: inherit !important"
    >
      {{ value.title }}
    </v-card-title>
    
    <v-card-subtitle 
      class="ma-0 pa-2" 
      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
      style="color: inherit !important"
    >
      {{ value.description }}
    </v-card-subtitle>

    <v-row v-if="value && value.items && value.items.length > 0" no-gutters>
      <v-col cols="12">
        <v-stepper v-if="showFeedback" v-model="e1" class="transparent" flat>
          <v-card
            class="rounded-lg px-2"
            color="rgba(255, 255, 255, .25)"
            outlined
          >
            <v-stepper-header
              class="flex-nowrap overflow-x-auto custom-scrollbar elevation-0"
            >
              <template v-for="i in value.items.length">
                <v-stepper-step
                  :id="`step-${i}`"
                  :key="`${i}-step`"
                  :complete="e1 > i"
                  :step="i"
                  class="py-2 px-6"
                >
                  <span class="text-no-wrap">{{ t("question") }} {{ i }}</span>
                </v-stepper-step>

                <v-divider v-if="i !== value.items.length" :key="i" />
              </template>
            </v-stepper-header>
          </v-card>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in value.items.length"
              :key="`${n}-content`"
              :step="n"
              class="pt-0 px-0"
            >
              <v-divider />

              <v-card class="mb-6 pa-2 transparent" flat>
                <pre 
                  v-html="value.items[n - 1].question" 
                  :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                />
                
                <feedback-type
                  :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                  v-model="valueComputed.items[n - 1].value"
                  :type="valueComputed.items[n - 1].type"
                  :current-lang="currentLang"
                />

                <v-textarea
                  v-if="value.items[n - 1].description"
                  v-model="valueComputed.items[n - 1].answer"
                  :label="
                    value.items[n - 1].forceDesc
                      ? t('description_required_label')
                      : t('description_optional_label')
                  "
                  :messages="t('description_hint')"
                  :class="[!isCurrentLangRTL ? 'force-ltr-input' : '']"
                  class="mt-4"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  outlined
                  rows="3"
                />
              </v-card>

              <div class="d-flex align-center">
                <v-btn
                  :disabled="n - 1 === 0"
                  class="me-2"
                  outlined
                  @click="e1 = n - 1"
                >
                  {{ t("back") }}
                </v-btn>

                <v-btn
                  :disabled="
                    (!value.items[n - 1].value &&
                      value.items[n - 1].value !== 0) ||
                    (value.items[n - 1].description &&
                      value.items[n - 1].forceDesc &&
                      (!value.items[n - 1].answer ||
                        value.items[n - 1].answer.length < 3))
                  "
                  color="primary"
                  @click="nextStep(n)"
                >
                  {{ n < value.items.length ? t("continue") : t("register") }}
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FeedbackType from "../cm/feedbackType";

export default {
  name: "bFeedbackView_multilang",

  components: { FeedbackType },

  props: {
    currentLang: {
      type: String,
      default: "fa",
    },
    lang: {
      type: String,
      default: "fa",
    },
    value: {
      type: [Object, Array],
      default: () => ({}),
    },
  },

  data: () => ({
    e1: 1,
    showFeedback: true,
  }),

  computed: {
    activeLang() {
      return this.currentLang || this.lang || "fa";
    },

    isCurrentLangRTL() {
      const rtlLangs = ["fa", "ar", "he", "ur"];
      return rtlLangs.includes(this.activeLang);
    },

    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    // متد اختصاصی برای دریافت ترجمه بر اساس زبان جاری کامپوننت بدون دستکاری لوکال عمومی
    t(key) {
      if (this.$i18n && typeof this.$i18n.t === "function") {
        return this.$i18n.t(key, this.activeLang);
      }
      return key;
    },

    nextStep(n) {
      if (n === this.value.items.length) {
        this.storeFeedback();
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },

    storeFeedback() {
      this.showFeedback = false;
      const successMsg = this.t("feedback_submitted_success");
      if (this.$toast && this.$toast.success) {
        this.$toast.success(successMsg);
      }
    },
  },
};
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title:before {
  content: "";
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;
  bottom: 0;
  right: 0;
  transition: all 0.3s ease;
}

/* اصلاح خط زیر عنوان برای حالت انگلیسی */
.section-title.title-ltr:before {
  right: auto !important;
  left: 0 !important;
}

pre {
  font-family: inherit !important;
  white-space: break-spaces;
  overflow: hidden;
}

/* استایل اجباری چپ‌چین برای اینپوت‌ها در صورت فعال بودن Vuetify RTL */
.force-ltr-input ::v-deep input,
.force-ltr-input ::v-deep textarea {
  text-align: left !important;
  direction: ltr !important;
}

.force-ltr-input ::v-deep .v-label {
  left: 0 !important;
  right: auto !important;
  transform-origin: top left !important;
  text-align: left !important;
}

.force-ltr-input ::v-deep .v-messages {
  text-align: left !important;
}

.force-ltr-input ::v-deep legend {
  text-align: left !important;
}
</style>
